import { createTheme } from "@mui/material";

export const theme = createTheme({
    palette: {
        primary: {
            main: "#4EAFB2",
            dark: "#013c4a",
            light: "#B2DFDB",
            contrastText: "#FFFFFF",
        },
        text: {
            primary: "#023c49",
            secondary: "#013c4a",
        },
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundColor: "#eef2f5",
                },
            },
        },
    },
    typography: {
        fontFamily: "Avenir",
        fontSize: 16,
        h4: {
            fontSize: 20,
            fontWeight: 500,
        },
        subtitle1: {
            fontSize: 14,
        },
    },
    overrides: {
        CssBaseline: {
            "@global": {
                "@font-face": ["Avenir"],
            },
        },
    },
});
